import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_PROJECTS_INFO_SUCCESS = 'FETCH_PROJECTS_INFO_SUCCESS';

export const fetchProjectsInfo = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/project-info.json`,
        {
            begin: ACTION_BEGIN,
            success: FETCH_PROJECTS_INFO_SUCCESS,
            failure: ACTION_FAILURE,
        });
